import Vue from 'vue'
import { $themeConfig } from '@themeConfig'

export function fetchStatuses() {
    return Vue.axios
        .get(`${$themeConfig.app.backUrl}/statuses`)
}

export function fetchOrders(limit, offset, paramsSearch, query) {
    const getStr = `${
        $themeConfig.app.backUrl
    }/orders?limit=${limit}&offset=${offset}${paramsSearch}${query}`

    return Vue.axios.get(getStr)
}

export function fetchErrorOrdersData() {
    return Vue.axios
        .get(`${$themeConfig.app.backUrl}/statuses/count?`, {
            params: {
                today: true,
                statuses: 'send_error'
            }
        })
}